import type { RouteRecordRaw } from 'vue-router'
import { getFirstAccessibleAdminRouteFromStorage } from '@/config/adminNavigation'
import { legacyAdminTenantRedirect } from './tenantScoped'

type AdminRouteDefinition = {
  path: string
  name: string
  title: string
  permission: string
  component: NonNullable<RouteRecordRaw['component']>
}

const adminRouteDefinitions: AdminRouteDefinition[] = [
  {
    path: 'tenant',
    name: 'admin-tenant',
    title: '租户管理',
    permission: 'tenant:profile:view',
    component: () => import('@/views/admin/TenantInfo.vue'),
  },
  {
    path: 'department',
    name: 'admin-department',
    title: '部门管理',
    permission: 'org:department:view',
    component: () => import('@/views/admin/DepartmentList.vue'),
  },
  {
    path: 'user',
    name: 'admin-user',
    title: '用户管理',
    permission: 'org:user:view',
    component: () => import('@/views/admin/UserList.vue'),
  },
  {
    path: 'audits',
    name: 'audits',
    title: '审计日志',
    permission: 'system:audit:view',
    component: () => import('@/views/admin/AuditList.vue'),
  },
  {
    path: 'roles',
    name: 'admin-roles',
    title: '角色管理',
    permission: 'permission:role:view',
    component: () => import('@/views/admin/RoleList.vue'),
  },
  {
    path: 'permissions',
    name: 'admin-permissions',
    title: '权限分配',
    permission: 'permission:role:view',
    component: () => import('@/views/admin/PermissionAssign.vue'),
  },
  {
    path: 'dict',
    name: 'admin-dict',
    title: '字典管理',
    permission: 'system:dict:view',
    component: () => import('@/views/admin/DictManagement.vue'),
  },
  {
    path: 'positions',
    name: 'admin-positions',
    title: '岗位库管理',
    permission: 'org:position:view',
    component: () => import('@/views/admin/PositionManagement.vue'),
  },
  {
    path: 'department-positions',
    name: 'admin-department-positions',
    title: '部门岗位管理',
    permission: 'org:department_position:view',
    component: () => import('@/views/admin/DepartmentPositionManagement.vue'),
  },
  {
    path: 'squads',
    name: 'admin-squads',
    title: '归属小分队',
    permission: 'org:squad:view',
    component: () => import('@/views/admin/SquadManagement.vue'),
  },
  {
    path: 'tracks',
    name: 'admin-tracks',
    title: '赛道配置',
    permission: 'org:track:view',
    component: () => import('@/views/admin/TrackManagement.vue'),
  },
  {
    path: 'im',
    name: 'admin-im',
    title: 'IM 集成',
    permission: 'integration:im:view',
    component: () => import('@/views/admin/ImSettings.vue'),
  },
  {
    path: 'org-integration',
    name: 'admin-org-integration',
    title: '组织同步',
    permission: 'integration:external_directory:view',
    component: () => import('@/views/admin/OrgIntegration.vue'),
  },
]

function createAdminChildren(withTenant: boolean): RouteRecordRaw[] {
  return adminRouteDefinitions.map(definition => {
    const route: RouteRecordRaw = {
      path: withTenant ? `t/:tenantCode/${definition.path}` : definition.path,
      component: definition.component,
      meta: {
      title: definition.title,
      permission: definition.permission,
      ...(withTenant ? {} : { legacyTenantRedirect: true }),
    },
    }

    if (withTenant) {
      route.name = definition.name
    } else {
      route.beforeEnter = legacyAdminTenantRedirect
    }

    return route
  })
}

const adminRoutes: RouteRecordRaw[] = [
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    redirect: () => getFirstAccessibleAdminRouteFromStorage(),
    children: [
      ...createAdminChildren(true),
      ...createAdminChildren(false),
    ],
  },
]

export default adminRoutes
